import { getStaticPathsForLocales } from '../../../../../features/app/pages/domain/use-cases/getStaticPathsForLocales';
import { FullAmendConfirmationPage } from '../../../../../features/parking/ui/booking-pages/full-amend/FullAmendConfirmationPage';

export const getStaticPaths = getStaticPathsForLocales;

export const getStaticProps = () => ({ props: {} });

export default FullAmendConfirmationPage;
